// Bootstrap 5 sidebar toggle functionality
export function initSidebar(): void {
  const sidebar = document.querySelector<HTMLElement>('.sidebar');
  const sidebarBackdrop = document.querySelector<HTMLElement>('.sidebar-backdrop');
  const menuToggleBtn = document.querySelector<HTMLElement>('.menu-toggle-btn');

  if (!sidebar || !menuToggleBtn) return;

  // Toggle sidebar on button click
  menuToggleBtn.addEventListener('click', function () {
    sidebar.classList.toggle('show');
    if (sidebarBackdrop) {
      sidebarBackdrop.classList.toggle('show');
    }
  });

  // Close sidebar when clicking backdrop
  if (sidebarBackdrop) {
    sidebarBackdrop.addEventListener('click', function () {
      sidebar.classList.remove('show');
      sidebarBackdrop.classList.remove('show');
    });
  }

  // Close sidebar when clicking a link on mobile
  const sidebarLinks = sidebar.querySelectorAll<HTMLAnchorElement>('a:not([data-bs-toggle])');
  sidebarLinks.forEach((link) => {
    link.addEventListener('click', function () {
      if (window.innerWidth < 992) {
        sidebar.classList.remove('show');
        if (sidebarBackdrop) {
          sidebarBackdrop.classList.remove('show');
        }
      }
    });
  });

  // Handle window resize
  window.addEventListener('resize', function () {
    if (window.innerWidth >= 992) {
      sidebar.classList.remove('show');
      if (sidebarBackdrop) {
        sidebarBackdrop.classList.remove('show');
      }
    }
  });
}
